import * as yup from 'yup'
export const addPaymentMethodSchema = yup.object().shape({
    name: yup
        .string()
        .required('من فضلك ادخل اسم طريقة الدفع التى تريدد اضافتها '),
    is_disabled: yup.boolean(),
})
